module.exports = __webpack_public_path__ + "static/media/clockwise.76552c7b.svg";